import React from "react";
import { motion } from "framer-motion";

const BASE = "https://customer-assets.emergentagent.com/job_la-fleur-studio/artifacts";
const BASE2 = "https://customer-assets-7cd3h4nn.emergentagent.net/job_la-fleur-studio/artifacts";

const IMAGES = [
  { src: `${BASE2}/0822yjob_ph1.webp`, h: "tall" },
  { src: `${BASE2}/k81xo4wk_ph6.webp`, h: "tall" },
  { src: `${BASE2}/tjc9eeao_IMG_6445%202.webp`, h: "tall" },
  { src: `${BASE2}/mesfa3qy_ph2.webp`, h: "tall" },
  { src: `${BASE2}/gyj1s986_ph1233.webp`, h: "tall" },
  { src: `${BASE2}/p4q1ilxr_IMG_4452.webp`, h: "tall" },
  { src: `${BASE2}/yzoz31bs_ph4.webp`, h: "square" },
  { src: `${BASE2}/4iwjy9qr_ph8.webp`, h: "tall" },
  { src: `${BASE2}/cmweosh8_IMG_1465.webp`, h: "tall" },
  { src: `${BASE2}/ji6zywdu_ph4%20.webp`, h: "tall" },
  { src: `${BASE2}/4n245cf2_ph9.webp`, h: "tall" },
  { src: `${BASE2}/22xqb0uy_b.webp`, h: "tall" },
  { src: `${BASE2}/x1su46w3_ph3.webp`, h: "tall" },
  { src: `${BASE2}/2d6zqr82_ph11.webp`, h: "tall" },
  { src: `${BASE2}/1hi9ie75_IMG_6093.webp`, h: "tall" },
  { src: `${BASE2}/gwwrp8eg_D9CBB300-713F-4EAB-9FE1-4A342CA071D6.webp`, h: "tall" },
  { src: `${BASE2}/vqyeh1yh_funeral%203.webp`, h: "tall" },
  { src: `${BASE2}/lalqu55m_funeral%201.webp`, h: "tall" },
  { src: `${BASE2}/aelpcvho_funeral%20.webp`, h: "tall" },
  { src: `${BASE2}/lirgju36_4%20funeral%20.webp`, h: "tall" },
  { src: `${BASE}/bcen7cmo_72134F4D-8A65-43B4-A2F0-8FF59A1F151D.JPG`, h: "tall" },
  { src: `${BASE}/f6wip2lm_2EE6A6EB-EF48-4D4E-8401-A957E5E6C7CF.JPG`, h: "tall" },
  { src: `${BASE}/ye8vstjq_E98AD418-E03F-44AF-BFE0-5213F3F8F0D6%202.JPG`, h: "square" },
  { src: `${BASE}/ros4vftn_IMG_9361.jpg`, h: "wide" },
];

const aspect = (h) => ({ tall: "3 / 4", wide: "4 / 3", square: "1 / 1" }[h]);

const Gallery = () => {
  return (
    <div className="lf-container py-16 md:py-24" data-testid="gallery-page">
      <div className="max-w-3xl">
        <span className="lf-eyebrow">Our work</span>
        <h1
          className="font-serif mt-4 leading-none"
          style={{ fontSize: "clamp(2.75rem, 6vw, 5rem)", fontWeight: 300, color: "var(--lf-ink)" }}
        >
          A little
          <br />
          <em style={{ color: "var(--lf-gold-deep)" }}>lookbook of love.</em>
        </h1>
        <p className="font-script text-3xl mt-4" style={{ color: "var(--lf-pink-deep)" }}>
          Luxury in every bloom.
        </p>
        <p className="mt-6 text-base md:text-lg max-w-xl leading-relaxed" style={{ color: "var(--lf-ink-soft)" }}>
          A small collection of bouquets, vase arrangements, and moments
          we've sent out into the world. Follow us on Instagram
          <a
            href="https://instagram.com/la_fleur_floreria"
            target="_blank"
            rel="noreferrer"
            className="underline mx-1"
            style={{ color: "var(--lf-gold-deep)" }}
          >
            @la_fleur_floreria
          </a>
          for the latest.
        </p>
      </div>

      <div className="mt-16 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-7">
        {IMAGES.map((img, i) => (
          <motion.div
            key={img.src}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
            className="lf-photo-card"
            style={{
              aspectRatio: aspect(img.h),
              background: "var(--lf-cream-2)",
              transform: `rotate(${(i % 3) - 1}deg)`,
            }}
            data-testid={`gallery-tile-${i}`}
          >
            <img
              src={img.src}
              alt=""
              loading="lazy"
              className="w-full h-full object-cover rounded-xl"
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
